import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { notificationsClient } from '#pplx_generated/typespec/rest/notifications/client.js';
export const listPairedDevices = async ({ reason, }) => {
    const { data, error, response } = await notificationsClient.GET('/rest/notifications/paired-devices', reason, {
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to list paired devices',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=listPairedDevices.js.map